<template>
  <div class="comment d-flex align-items-start mt-2  pl-3 pt-4" v-if="data.postID">
    
    <!-- <div v-for="(item, index) in data" :key="index" class="d-flex align-items-start mt-2"> -->
    <router-link
        :to="'/userindex/'+data.userID">
<!--  <div class="float-left">-->
    <el-popover
        placement="top-start"
        :width="340"
        trigger="hover"
        :open-delay="700"
    >
      <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">
      </User-Infor-Card>
      <div slot="reference">
        <avatar :data="data.userinfo_userID" :imgHeight="38" class="mr-2 "></avatar>
        </div>
      </el-popover>
    </router-link>
<!--  </div>-->
        <div class="flex-fill">
          <div class="d-flex w-100 pt-1">
            <el-popover
                placement="top-start"
                :width="340"
                trigger="hover"
                :open-delay="700"
            >

              <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">

              </User-Infor-Card>
            <div slot="reference" class="replyName text-black">{{data.userinfo_userID.username}}</div>
            </el-popover>
            <span class="replyTime">{{data.edit_date*1000 | formatDate}}</span>
            <span class="ml-auto">
              <drop-down
              class="nav-item dropdown"
              :haiwaiIcon="iconmore3v"
              :hideArrow="true"
              haiwaiClass="haiwaiicon"
              style="padding:0;"
              >
                <!-- <el-popover 
                placement="bottom-start"
                width="375" 
                :ref="'report0-'+data.postID"
                trigger="click">
                  <div>我要举报 <b>{{data.userinfo_userID.username}}</b><span v-if="report_status" class="text-success ml-3">举报成功</span></div>
                  <textarea  type="textarea" v-model="reportmsgbody" rows="3" class="w-100 my-2 p-2" placeholder="写下您的举报原因..." @keyup="checkstatus(1)" maxlength="400"></textarea>
                  <n-button 
                  type="primary"
                  round 
                  simple
                  :disabled="replybtndisable"
                  @click="report('0',data)"
                    >举报</n-button
                  >
                  <a class="dropdown-item" href="javascript:void(0)" slot="reference" style="color:gray"><span>举报</span></a>
                </el-popover> -->
                <!-- <a class="dropdown-item" href="javascript:void(0)" @click="report(data)">举报</a> -->
                <a class="dropdown-item pl-4" href="javascript:void(0)" style="color:gray" @click="blockUser(data.userID)">{{$t('message').article.black_list}}</a>
            </drop-down>
            </span>
          </div>
      
          <p class="replyContent" v-html="data.postInfo_postID.msgbody"></p>
          <p class="replyFoot">
            <span class="mr-4" v-if="!$store.state.user.check_is_wxcblog_domain()"
            @click="like(data)">
              <icon-like-outline 
              :style="{fill:data.postInfo_postID.is_buzz==1?'#39b8eb':'gray',height:'18px',cursor:'pointer'}"></icon-like-outline>{{data.countinfo_postID.count_buzz}}</span>

            <icon-message :style="{fill:'gray',height:'18px'}" ></icon-message>
            <el-popover 
              placement="bottom-start"
              width="375" 
              :ref="'pop-'+data.postID"
              trigger="click">
                <textarea  type="textarea" v-model="replymsgbody" rows="3" class="w-100 my-2 p-2" :placeholder="$t('message').article.comment_placeholder" @keyup="checkstatus"></textarea>
                <n-button 
                type="primary"
                round 
                simple
                :disabled="replybtndisable"
                @click="reply_add()"
                  >{{$t('message').article.reply}}</n-button
                >
                <a href="javascript:void(0)" slot="reference" @click="reply(data)" style="color:gray"><span>{{$t('message').article.reply}}</span></a>
              </el-popover>
            <!-- <a style="color:gray" @click="reply(data)">回复</a> -->
            <el-popconfirm v-if="data.userID==loginuserID || author==loginuserID "
              placement="top-end"
              :confirm-button-text="$t('message').article.comment_delet"
              :cancel-button-text="$t('message').article.comment_cancel"
              :title="$t('message').article.comment_del_confirm"
              :hide-icon="true"
              @confirm="article_reply_delete(data)"
            >
              <a href="javascript:void(0)" slot="reference" class="ml-5" style="color:gray">{{$t('message').article.comment_delet}}</a>
            </el-popconfirm>
            <span  v-if="$store.state.user.userinfo.UserLevel==2">
              <span v-if="data.visible==0" class="text-warning mx-3">已删除</span>
              <a v-if="data.visible==0" href="javascript:void(0)" @click="admin_reply_delete(data,1)">恢复</a>

              <el-popconfirm v-if="data.visible!==0"
                placement="top-end"
                confirm-button-text='删除'
                cancel-button-text='取消'
                title="确定删除这条评论吗？其下的所有回复将一并删除！"
                :hide-icon="true"
                @confirm="admin_reply_delete(data,0)"
              >
                <a href="javascript:void(0)" slot="reference" class="ml-5" >管理员删除</a>
              </el-popconfirm>
            </span>
            
          </p>
          <!-- <a
          v-if="item.userID==loginuserID" class="ml-5" style="color:gray" >删除</a> -->
          <!-- <div v-if="item.replies.length>0"> https://cloud.tencent.com/developer/article/1360724 -->
          <div v-if="data.reply">
            <div :id="data.postID" style="display:none">
              <div v-for="(r,idx) in data.reply" :key="'r'+idx" class="d-flex align-items-start mt-2">
                <avatar :data="r.userinfo_userID" :imgHeight="32" class="mr-2"></avatar>
                <div class="flex-fill">
                  <div class="d-flex w-100">
                    <span class="replyName">{{r.userinfo_userID.username}}</span>
                    <span class="ml-2 text-primary" style="font-size:0.85rem" v-if="r.userID==author">[作者]</span>
                    <span class="replyTime">{{r.edit_date*1000 | formatDate}}</span>
                    <span class="ml-auto">
                      <drop-down
                      class="nav-item dropdown"
                      :haiwaiIcon="iconmore3v"
                      :hideArrow="true"
                      haiwaiClass="haiwaiicon"
                      style="padding:0;"
                    >
                      <!-- <el-popover 
                      placement="bottom-start"
                      width="375" 
                      :ref="'report1-'+r.postID"
                      trigger="click">
                        <div>我要举报 <b>{{r.userinfo_userID.username}}</b><span v-if="report_status" class="text-success ml-3">举报成功</span></div>
                        <textarea  type="textarea" v-model="reportmsgbody" rows="3" class="w-100 my-2 p-2" placeholder="写下您的举报原因..." @keyup="checkstatus(1)" maxlength="400"></textarea>
                        <n-button 
                        type="primary"
                        round 
                        simple
                        :disabled="replybtndisable"
                        @click="report('1',r)"
                          >举报</n-button>
                        <a class="dropdown-item" href="javascript:void(0)" slot="reference" style="color:gray"><span>举报</span></a>
                      </el-popover> -->
                      <a class="dropdown-item pl-4" href="javascript:void(0)" @click="blockUser(r.userID)">{{$t('message').article.black_list}}</a>
                    </drop-down>
                    </span>
                  </div>
                    
                    <p class="replyContent" v-html="r.postInfo_postID.msgbody"></p>
                    <p class="replyFoot">
                      <span @click="like(r)"><icon-like-outline :style="{fill:r.postInfo_postID.is_buzz==1?'#39b8eb':'gray',height:'18px',cursor:'pointer'}"></icon-like-outline></span>{{r.countinfo_postID.count_buzz}}
                      <icon-message :style="{fill:'gray',height:'18px'}" class="ml-4"></icon-message>
                      <el-popover 
                      placement="bottom-start"
                      width="375" 
                      @show="reply(r)"
                      :ref="'pop-'+r.postID"
                      trigger="click">
                        <textarea style="border: #ddd 1px solid;" type="textarea" v-model="replymsgbody" rows="3" class="w-100 my-2" :placeholder="$t('message').article.comment_placeholder" @keyup="checkstatus"></textarea>
                        <n-button 
                          type="primary"
                          round 
                          simple
                          :disabled="replybtndisable"
                          @click="reply_add()"
                            >{{$t('message').article.reply}}</n-button
                          >
                        <a href="javascript:void(0)" slot="reference" style="color:gray" ><span>{{$t('message').article.reply}}</span></a>
                      </el-popover>
                      
                      <el-popconfirm v-if="r.userID==loginuserID || author==loginuserID "
                        placement="top-end"
                        :confirm-button-text="$t('message').article.comment_delet"
                        :cancel-button-text="$t('message').article.comment_cancel"
                        :title="$t('message').article.reply_del_confirm"
                        :hide-icon="true"
                        @confirm="article_reply_delete(r)"
                      >
                        <a href="javascript:void(0)" slot="reference" class="ml-5" style="color:gray;">{{$t('message').article.comment_delet}}</a>
                      </el-popconfirm>
                       <span  v-if="$store.state.user.userinfo.UserLevel==2">
                          <span v-if="r.visible==0" class="text-warning mx-3">已删除</span>
                          <a v-if="r.visible==0" href="javascript:void(0)" @click="admin_reply_delete(r,1)">恢复</a>

                          <el-popconfirm v-if="r.visible!==0"
                            placement="top-end"
                            confirm-button-text='删除'
                            cancel-button-text='取消'
                            title="确定删除这条回复吗？"
                            :hide-icon="true"
                            @confirm="admin_reply_delete(r,0)"
                          >
                            <a href="javascript:void(0)" slot="reference" class="ml-5" >管理员删除</a>
                          </el-popconfirm>
                        </span>
                    </p>
                </div>
              </div>
            </div>
            <button 
            v-if="data.reply.length>0"
            class="btn btn-link btn-info" 
            style="padding-left:0px" 
            v-on:click="replystatus(data.postID)">
              {{replyshowstatus}} {{data.reply.length}} {{$t('message').article.reply_count}}<span class="ml-2" v-if="has_author">[含作者]</span>
            </button>
          </div>
      </div>
    <!-- </div> -->
<!-- 回复 modal -->
    <modal :show.sync="modals.reply" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up" style="padding-top:5px"><span class="text-muted">{{$t('message').article.reply}}</span> {{currentItem.userinfo_userID.username}} <span class="text-muted">{{$t('message').article.comment_text}}</span></h4>
      <textarea type="textarea" v-model="replymsgbody" rows="3" class="w-100 my-2" placeholder="写下您的评论..." @keyup="checkstatus"></textarea>
      <template slot="footer">
        <n-button 
        class="mr-3"
        type="default" 
        link
        @click.native="modals.reply = false"
        >
          {{$t('message').article.comment_cancel}}
        </n-button>
        <n-button 
        type="primary"
        round 
        simple
        :disabled="replybtndisable"
        @click="reply_add()"
          >{{$t('message').article.reply}}</n-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import {IconLikeOutline,IconMessage} from '@/components/Icons';
import HaiwaiIcons from "@/components/Icons/Icons";
import { Modal, Button,DropDown } from '@/components';
import Avatar from '../components/Main/Avatar';
import {formatDate} from '@/directives/formatDate.js';
import blog from '../../blog.service';
import {Popover} from 'element-ui';
import UserInforCard from '@/module/user/components/UserInforCard';

export default {
  name: 'comment',
  props:{
      data:{},
      author:Number,
  },
  components: {
      Avatar,
      IconLikeOutline,
      IconMessage,
      Modal,
      DropDown,
      [Button.name]: Button,
      [Popover.name]:Popover,
       UserInforCard,
  },
  mounted: function () {
    let userinfor = this.$store.state.user.userinfo
    this.loginuserID = userinfor?userinfor.UserID:-1;
  },
  computed:{
    has_author () {
      let s = 0
      this.data.reply.forEach(obj=>{
        if(obj.userID == this.author) {
          s++
        } ;
      })
      return s>0?true:false
    }
  },
  methods:{
    // logedin () {
    //   let status;
    //   account.login_status().then(res=>{ //判断是否登录
    //     if(res.data==undefined){
    //       status = false;
    //     }else{
    //       status = true ;
    //     }
    //     return status;
    //   })
    // },
    // 点赞、取消点赞
    like(item){
      if(!this.check_user_login())  return;
      this.currentItem = item ;
      item.postInfo_postID.is_buzz==0?this.buzz_add(item):this.buzz_delete(item);
    },
    buzz_add(item){
      blog.buzz_add(item.postID).then(res=>{
        this.regetComment(item);
      })
    },
    buzz_delete(item){
      blog.buzz_delete(item.postID).then(res=>{
        this.regetComment(item);
      })
    },
    // 回复
    reply(item){
      this.currentItem = item ;
        if(item.treelevel==2){
          this.replymsgbody = "@"+ item.userinfo_userID.username +"  ";
        }else{
          this.replymsgbody = "";
        }
    },
    reply_add(){
      let obj = {
        article_data:{
          msgbody:this.wrapToBr(this.replymsgbody),
          postID:this.currentItem.treelevel==2?this.currentItem.basecode:this.currentItem.postID,
          typeID:1}
      }
      let pop = 'pop-'+this.currentItem.postID;
      this.replybtndisable = true;
      if(!this.check_user_login())  return;
      blog.reply_add(obj).then(res=>{
        if(res.status){
          this.regetComment(this.currentItem);
        }else{
          this.$message.error(res.error)
        }
        this.replybtndisable = false;
        this.currentItem.treelevel==2?this.$refs[`${pop}`][0].doClose():this.$refs[`${pop}`].doClose();
        this.replymsgbody="";
      })
    },
    // 删除回复
    article_reply_delete(item){
      blog.reply_delete(item.postID).then(res=>{
        if(res.status){
          this.regetComment(item);
        }
      })
    },
    admin_reply_delete(item,visible){
      this.$store.state.user.admin_reply_delete(item.postID,visible).then(res=>{
        if(res.status){
          item.visible = visible
        }
      })
    },
    regetComment(item){
      let id = 0;
      if(item.treelevel==2){
        id = item.basecode;
      }else{
        id = item.postID;
      }
      this.$emit("regetcomment",id);
    },
    checkstatus(type){
      if(type==1){
        this.replybtndisable = this.reportmsgbody?false:true;
      }else{
        this.replybtndisable = this.replymsgbody?false:true;
      }
    },
    replystatus(id){
      let obj = document.getElementById(id);
      obj.style.display = obj.style.display=='none'?'block':'none';
      this.replyshowstatus = obj.style.display=='none'?'显示':'隐藏';
    },
    //拉黑
    blockUser(id){
      if(!this.check_user_login())  return;
      this.$store.state.user.blacklist_add(id).then(res=>{
        if(res.status){
          this.$message({message:'已加黑名单',type:'success'})
        }
      })
    },
    //举报
    report(n,data){
      if(!this.check_user_login())  return;
      let pop = 'report'+n+'-'+data.postID;
      this.$store.state.user.report_add(data.userID,this.reportmsgbody).then(res=>{
        this.report_status = true;
        setTimeout(()=>{
          this.report_status = false;
          this.$refs[`${pop}`].doClose();
        },2000)
      })
    },
    wrapToBr(text) {
      var string = text;
      try {
          string = string.replace(/\r\n/g, "<br>")
          string = string.replace(/\n/g, "<br>");
          string = string.replace(/\r/g, "<br>");
          string = string.replace(/\s/g,"&nbsp;");
      } catch (e) {
          console.log(e.message);
      }
      return string;
    }
  },
  data(){
    return {
      iconmore3v: HaiwaiIcons.iconmore3v,
      loginuserID:-1,
      replyshowstatus:'显示',
      replymsgbody:'',
      reportmsgbody:'',
      report_status:false,
      replyusername:'',
      replybtndisable:true,
      noMore:false,
      currentItem:{userinfo_userID:{username:''}},
      modals: {
        reply: false,
        delete: false,
        login:false
      },
    }
  },
  filters: {
    formatDate(time) {
        var date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }

};
</script>
<style>

.fontsize0 .comment .replyContent{
  font-size: 1rem;
}
.fontsize1 .comment .replyContent{
  font-size: 1.2rem;
}
.fontsize2 .comment .replyContent{
  font-size: 1.4rem;
}

.comment .replyContent,.comment .replyFoot{
    font-size: 1rem;
    margin-bottom: 3px;
}
.comment .replyName{
    font-weight: 700;
}
.comment .replyTime{
    color:gray;
    font-size: .875rem;
    margin-left: 1rem;
}
.comment .haiwaiicon svg{
  fill:grey
}
@media (max-width: 575.98px){

}
</style>
